import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [complete, setComplete] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirmation) {
      toast.error("Parolalar eşleşmiyor");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setComplete(true);
      toast.success("Parolanız güncellendi");
    } catch (error) {
      toast.error(formatApiError(error.response?.data?.detail) || "Parola sıfırlanamadı");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-background acas-grid" data-testid="reset-password-page">
      <div className="w-full max-w-sm p-8 rounded-lg border border-border/60 bg-card acas-fade-up">
        <Link to="/giris" className="text-xs text-muted-foreground inline-flex items-center gap-1 hover:text-foreground mb-6" data-testid="reset-back-to-login">
          <ArrowLeft size={14} /> Girişe dön
        </Link>
        <div className="acas-eyebrow mb-2">Parola Sıfırlama</div>
        <h1 className="text-2xl font-bold tracking-tight mb-2" data-testid="reset-password-title">Yeni parola oluşturun</h1>

        {!token ? (
          <p className="text-sm text-muted-foreground" data-testid="reset-password-missing-token">Bu sıfırlama bağlantısı geçersiz veya eksik.</p>
        ) : complete ? (
          <div className="rounded-md border border-primary/20 bg-primary/5 p-4 text-sm" data-testid="reset-password-success">
            <div className="font-semibold text-primary mb-1">Parolanız güncellendi</div>
            <Link to="/giris" data-testid="reset-password-login-link" className="text-primary hover:underline">Giriş yapın</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="new-password">Yeni parola</Label>
              <Input id="new-password" type="password" minLength={6} required value={password} onChange={(event) => setPassword(event.target.value)} data-testid="reset-password-input" className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password-confirmation">Yeni parolayı tekrar yazın</Label>
              <Input id="password-confirmation" type="password" minLength={6} required value={confirmation} onChange={(event) => setConfirmation(event.target.value)} data-testid="reset-password-confirmation" className="mt-1.5" />
            </div>
            <Button type="submit" disabled={busy} className="w-full" data-testid="reset-password-submit">
              {busy ? "Güncelleniyor…" : "Parolayı güncelle"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}